import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControl,
} from "@material-ui/core";
import {
  UserFields,
  AddressFields,
  TypeFields,
} from "./UserFields";

import {
  validateEmail,
  validatePhone,
  validateZip,
} from "../../util/validations";
import SelectOffer from "../Renewal/Offers";
import { ClipLoader } from "react-spinners";
import moment from "moment";

export function getProperPromoCode(csa_type, inputtedPromo) {
  if (inputtedPromo) {
    return inputtedPromo
  } else if (csa_type === "tenant") {
    return "CSA"
  } else {
    return "default"
  }
}

const UserFieldsComponent = ({ userDetails, setUserDetails, setOffers, setProduct, setAddress, setStep, startDate, selectedStartDate, setSelectedStartDate, inputtedPromo, setInputtedPromo, closeDialog }) => {

  const validateInput = () => {
    const phoneOk = validatePhone(userDetails.phone);
    const emailOk = validateEmail(userDetails.email);
    const zipOk = validateZip(userDetails.billing_address.postal_code);
    const userOk = userDetails.first_name && userDetails.last_name;
    const addressOk = userDetails.billing_address.line1;
    const serviceZipOk = validateZip(userDetails.service_postal_code)
    const csaTypeOk = userDetails.csa_type !== ""
    return userOk && addressOk && phoneOk && emailOk && zipOk && serviceZipOk && csaTypeOk;
  }

  return (<>
    <DialogTitle>
      Add CSA Owner
    </DialogTitle>
    <DialogContent>
      <FormControl fullWidth >
        <UserFields userDetails={userDetails} setUserDetails={setUserDetails} />
        <br />
        <Typography variant="h6">Billing Address</Typography>
        <br />
        <AddressFields address={userDetails.billing_address} setAddress={setAddress} />
        <br />
        <Typography variant="h6">CSA Details</Typography>
        <br />
        <TypeFields userDetails={userDetails} setUserDetails={setUserDetails} startDate={selectedStartDate} setSelectedStartDate={setSelectedStartDate} inputtedPromo={inputtedPromo} setInputtedPromo={setInputtedPromo}/>
      </FormControl>
    </DialogContent >
    <DialogActions>
      <Button
        color="secondary"
        variant="contained"
        onClick={() => {
          setSelectedStartDate(startDate)
          closeDialog()
        }}
      >
        Cancel
      </Button>
      <Button
        color="primary"
        variant="contained"
        disabled={!validateInput()}
        onClick={() => {
          setOffers([])
          setProduct(null)
          setStep(2)
        }}
      >
        Continue
      </Button>
    </DialogActions>
  </>)
}
const OffersComponent = ({ userDetails, offers, setOffers, setProduct, setStep, closeDialog, doCreateCSA, setInputtedPromo, loading }) => {
  return (
    <>
      <DialogTitle>
        Select Offer
      </DialogTitle>
      <DialogContent>
        {
          loading ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '20px'
            }}>
              <ClipLoader sizeUnit="px" size={100} color="#ED0874" loading />
            </div>
          ) : offers.length === 0 ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              margin: '20px'
            }}>
              There are no offers available for that zip code
            </div>
          ) : (
            <div style={{
              display: 'flex',
              justifyContent: 'center'
            }}>
              <SelectOffer
                energyLevel={"2"}
                offers={offers}
                onOfferSelected={(offer) => setProduct(offer)}
                offerSelected={userDetails?.product}
              />
            </div>
          )
        }
      </DialogContent >
      <DialogActions>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => {
            setOffers([])
            setProduct(null)
            setInputtedPromo("")
            setStep(1)
          }}
        >
          Go Back
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={userDetails?.product === null}
          onClick={() => {
            setInputtedPromo("")
            doCreateCSA(userDetails);
            closeDialog();
          }}
        >
          Add CSA
        </Button>
      </DialogActions>
    </>
  )
}

const AddCSADialog = ({ closeDialog, doCreateCSA, doFetchProductOffers }) => {
  const [step, setStep] = useState(1)
  const time = moment.tz()
  const localtz = moment.tz.guess()
  const date = time.clone().tz(localtz)
  const startDate = moment(date).format("YYYY-MM-DD")
  const [offers, setOffers] = useState([])
  const [selectedStartDate, setSelectedStartDate] = useState(startDate)
  const [inputtedPromo, setInputtedPromo] = useState("")
  const [loading, setLoading] = useState(false)
  const [userDetails, setUserDetails] = useState({
    company_name: "",
    email: "",
    phone: "",
    first_name: "",
    last_name: "",
    language: "en",
    billing_address: {
      line1: "",
      line2: "",
      city: "",
      state: "TX",
      postal_code: "",
    },
    product: null,
    service_postal_code: "",
    start_date: startDate,
    csa_type: "",
    on_consolidated_billing: false,
    tdsp_duns: "",
    credit_approved_meters: false,
    disable_meter_notifications: false,
  });

  const setProduct = (newProduct) => {

    if (!newProduct) {
      setUserDetails({
        ...userDetails,
        product: newProduct,
      });
    } else {
      setUserDetails({
        ...userDetails,
        product: {
          ...newProduct,
          start_date: new Date(selectedStartDate).toISOString(),
          tdsp_duns: userDetails.tdsp_duns,
          promo_code: getProperPromoCode(userDetails.csa_type, inputtedPromo),
        },
      });
    }
  }

  const setAddress = newAddress => {
    setUserDetails({
      ...userDetails,
      billing_address: newAddress,
    });
  }

  const getOffers = async (zipCode, promo_code) => {
    setLoading(true);

    const allOffers = await doFetchProductOffers({ postal_code: zipCode, promo_code: promo_code });
    if (allOffers?.tdsps && allOffers?.tdsps[0]) {
      setUserDetails({
        ...userDetails,
        tdsp_duns: allOffers?.tdsps[0].duns_number
      })
      setOffers(allOffers?.tdsps[0].offers)
    } else {
      setOffers([])
    }
    setLoading(false);
  }

  useEffect(() => {
    if (step === 2) {
      getOffers(userDetails.service_postal_code, getProperPromoCode(userDetails.csa_type, inputtedPromo))
    }
  }, [step])

  return <Dialog
    open={true}
    fullWidth
    maxWidth="md"
  >
    {step === 1 && (
      <UserFieldsComponent
        userDetails={userDetails}
        setUserDetails={setUserDetails}
        setOffers={setOffers}
        setProduct={setProduct}
        setAddress={setAddress}
        setStep={setStep}
        startDate={startDate}
        selectedStartDate={selectedStartDate}
        setSelectedStartDate={setSelectedStartDate}
        inputtedPromo={inputtedPromo}
        setInputtedPromo={setInputtedPromo}
        closeDialog={closeDialog}
      />
    )}
    {step === 2 && (
      <OffersComponent
        userDetails={userDetails}
        setOffers={setOffers}
        setProduct={setProduct}
        setStep={setStep}
        doCreateCSA={doCreateCSA}
        offers={offers}
        closeDialog={closeDialog}
        setInputtedPromo={setInputtedPromo}
        loading={loading}
      />
    )}
  </Dialog >
}

export default AddCSADialog;
